import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { ConfigureChainCalendarComponent } from './pages/configure-chain-calendar/configure-chain-calendar.component';
import { ConvertGoodsAttributeComponent } from './pages/convert-goods-attribute/convert-goods-attribute.component';
import { ErrorComponent } from './pages/error/error/error.component';
import { MaintenanceComponent } from './pages/error/maintenance/maintenance.component';
import { NotFoundComponent } from './pages/error/not-found/not-found.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { RegisterGoodsComponent } from './pages/register-goods/register-goods.component';
import { RegisterNewGoodsComponent } from './pages/register-new-goods/register-new-goods.component';
import { SetMaintenanceControlsComponent } from './pages/set-maintenance-controls/set-maintenance-controls.component';
import { SetReferenceControlsComponent } from './pages/set-reference-controls/set-reference-controls.component';
import { SolveUnmatchedGoodsComponent } from './pages/solve-unmatched-goods/solve-unmatched-goods.component';
import { SolveUnmatchedStoresComponent } from './pages/solve-unmatched-stores/solve-unmatched-stores.component';
import { TestComponent } from './pages/test/test.component';
import { UpdateCalendarComponent } from './pages/update-calendar/update-calendar.component';
import { UpdateChainsComponent } from './pages/update-chains/update-chains.component';
import { UpdateGoodsComponent } from './pages/update-goods/update-goods.component';
import { UpdateStoresComponent } from './pages/update-stores/update-stores.component';
import { LoggedInGuard } from './services/guard/logged-in.guard';

const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [LoggedInGuard]},
  { path: 'home', component: HomeComponent, canActivate: [LoggedInGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'test', component: TestComponent, canActivate: [LoggedInGuard] },
  { path: 'error', component: ErrorComponent },
  { path: 'maintenance', component: MaintenanceComponent },
  { path: 'configure-chain-calendar', component: ConfigureChainCalendarComponent, canActivate: [LoggedInGuard] },
  { path: 'convert-goods-attribute', component: ConvertGoodsAttributeComponent, canActivate: [LoggedInGuard] },
  { path: 'register-goods', component: RegisterGoodsComponent, canActivate: [LoggedInGuard] },
  { path: 'register-new-goods', component: RegisterNewGoodsComponent, canActivate: [LoggedInGuard] },
  { path: 'set-maintenance-controls', component: SetMaintenanceControlsComponent, canActivate: [LoggedInGuard] },
  { path: 'set-reference-controls', component: SetReferenceControlsComponent, canActivate: [LoggedInGuard] },
  { path: 'solve-unmatched-goods', component: SolveUnmatchedGoodsComponent, canActivate: [LoggedInGuard] },
  { path: 'solve-unmatched-goods/:chainCd', component: SolveUnmatchedGoodsComponent, canActivate: [LoggedInGuard] },
  { path: 'solve-unmatched-stores', component: SolveUnmatchedStoresComponent, canActivate: [LoggedInGuard] },
  { path: 'update-calendar', component: UpdateCalendarComponent, canActivate: [LoggedInGuard] },
  { path: 'update-goods', component: UpdateGoodsComponent, canActivate: [LoggedInGuard] },
  { path: 'update-stores', component: UpdateStoresComponent, canActivate: [LoggedInGuard] },
  { path: 'update-chains', component: UpdateChainsComponent, canActivate: [LoggedInGuard] },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    relativeLinkResolution: 'legacy'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
